import React from "react";
import DashboardLayout from "./DashboardLayout";
import FranchiseApplicationForm from "../components/FranchiseApplicationForm";

function Franchise() {
  return (
    <DashboardLayout>
      <div className="container-fluid py-2 py-lg-3">
        <FranchiseApplicationForm mode="admin" />
      </div>
    </DashboardLayout>
  );
}

export default Franchise;
